import { AlertCircle, AlertTriangle, CheckCircle2, Info, type LucideIcon } from "lucide-react";
import { cn } from "@/lib/cn";

/**
 * Banner informativo/estado homologado (doc UX 20260627: "dar mayor
 * protagonismo a los mensajes importantes y reducir los repetitivos").
 * Reemplaza los `div` inline azul/ámbar repartidos por las pantallas.
 */
export type AlertVariant = "info" | "warning" | "error" | "success";

const STYLES: Record<AlertVariant, { wrap: string; icon: string; Icon: LucideIcon }> = {
  info: { wrap: "border-estado-info/25 bg-estado-info-bg text-estado-info", icon: "text-estado-info", Icon: Info },
  warning: { wrap: "border-estado-warn/25 bg-estado-warn-bg text-estado-warn", icon: "text-estado-warn", Icon: AlertTriangle },
  error: { wrap: "border-estado-err/25 bg-estado-err-bg text-estado-err", icon: "text-estado-err", Icon: AlertCircle },
  success: { wrap: "border-estado-ok/25 bg-estado-ok-bg text-estado-ok", icon: "text-estado-ok", Icon: CheckCircle2 },
};

export function Alert({
  variant = "info",
  title,
  className,
  children,
}: {
  variant?: AlertVariant;
  title?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
}) {
  const s = STYLES[variant];
  const Icon = s.Icon;
  return (
    <div
      role={variant === "error" ? "alert" : undefined}
      className={cn("flex items-start gap-2.5 rounded-lg border p-3 text-sm", s.wrap, className)}
    >
      <Icon className={cn("mt-0.5 h-4 w-4 shrink-0", s.icon)} />
      <div className="min-w-0">
        {title && <div className="font-medium">{title}</div>}
        {children && <div className={cn(title && "mt-0.5")}>{children}</div>}
      </div>
    </div>
  );
}
